import { DataActiveStatusEnum } from "../../Category/types";
import { GroupState, IData } from "../types";

export const defaultFormData:IData = {
  _id: "",
  createdAt: "",
  updatedAt: "",
  title: "",
  status: DataActiveStatusEnum.ACTIVE,
  packageId: "",
  packageTitle: ""
};
export const initialState: GroupState = {
  formData: { ...defaultFormData },
  list: [],
  allList: [],
  loading: false,
  buttonLoading: false,
  search: "",
  pageNo: 1,
  pageSize: 30,
  totalRow: 0,
  orderBy: "",
  orderDir: "",
  toggleLoading: false,
  groupPackage: []
};
